
import { Component, Inject, Vue } from "vue-property-decorator";
import { Container } from "inversify";
import MobileFilterModal from "./MobileFilterModal.vue";
import ServiceFilter from "../filters/ServiceFilter.vue";
import ProductFilter from "../filters/ProductFilter.vue";
import OperatingRegimeFilter from "../filters/OperatingRegimeFilter.vue";
import ApplicationFilter from "../filters/ApplicationFilter.vue";
import { OrganizationFilterStore } from "../../../stores/organization/OrganizationFilterStore";
import countries, { ICountry, IState } from "../../../../../vendor/country-state-city";
import { OrganizationListStore } from "../../../stores/organization/OrganizationListStore";
import CountryFilter from "../filters/CountryFilter.vue";
import { handleError } from "../../../../../common/src/utility/errorUtils";
import { ApplicationTypeStore } from "../../../../../common/src/stores/ApplicationTypeStore";
import { ProductTypeStore } from "../../../../../common/src/stores/ProductTypeStore";
import { ServiceTypeStore } from "../../../../../common/src/stores/ServiceTypeStore";
import { OperatingRegimeTypeStore } from "../../../../../common/src/stores/OperatingRegimeTypeStore";

@Component({
    components: {
        MobileFilterModal,
        ProductFilter,
        ServiceFilter,
        ApplicationFilter,
        OperatingRegimeFilter,
        CountryFilter,
    },
})
export default class GeographicToolMobileSidebar extends Vue {
    @Inject("container") readonly container!: Container;
    organizationFilterStore: OrganizationFilterStore = this.container.get(OrganizationFilterStore);
    readonly organizationListStore: OrganizationListStore =
        this.container.get(OrganizationListStore);
    readonly applicationFilterStore: ApplicationTypeStore = this.container.get(
        "OrganizationApplicationTypeStore",
    );
    readonly serviceFilterStore: ServiceTypeStore = this.container.get(
        "OrganizationServiceTypeStore",
    );
    readonly productFilterStore: ProductTypeStore = this.container.get(
        "OrganizationProductTypeStore",
    );
    readonly operatingRegimeFilterStore: OperatingRegimeTypeStore = this.container.get(
        "OrganizationOperatingRegimeTypeStore",
    );

    created() {
        this.applicationFilterStore.load().catch(handleError);
        this.serviceFilterStore.load().catch(handleError);
        this.productFilterStore.load().catch(handleError);
        this.operatingRegimeFilterStore.load().catch(handleError);
    }

    get countries(): ICountry[] {
        return countries
            .getAllCountries()
            .filter((country) =>
                this.organizationListStore.items?.some((org) => org.country === country.name),
            );
    }

    get states(): IState[] {
        let statesFromCountries: IState[] = [];
        this.countries.forEach((country) => {
            let states = countries.getStatesOfCountry(country.id);
            statesFromCountries = statesFromCountries.concat(
                states.filter((state) =>
                    this.organizationListStore.items?.some(
                        (org) => org.state === state.name && org.country === country.name,
                    ),
                ),
            );
        });
        return statesFromCountries;
    }
}
